"use client";

import Core from "@/components/core";
import Layouts from "@/components/layouts";
import { usePathname } from "next/navigation";
import { useFetchNewsData } from "@/hooks/fetchNewsData";
import { useState, useEffect } from "react";
import { Suspense } from "react";
import LoadingSkeleton from "@/app/loading";
import { Skeleton } from "@/components/ui/skeleton";
import dynamic from "next/dynamic";

interface NewsLayoutProps {
  children: React.ReactNode;
}

const DynamicNews = dynamic(
  () => import("@/components/core/(Articles)/Articles"),
  {
    ssr: false,
  }
);

const NewsLayouts: React.FC<NewsLayoutProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const newsData = useFetchNewsData();

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Layouts.Section>
        <Core.Title title="Berita" subtitle="Berita" />
        <div className="grid md:grid-cols-12 grid-cols-1 gap-[30px]">
          <div className="lg:col-span-8 col-auto md:col-span-6">{children}</div>
          <div className="lg:col-span-4 col-auto md:col-span-6">
            <Layouts.SidebarLayanan title="Berita Terkini">
              <Suspense fallback={<LoadingSkeleton />}>
                {isLoading ? (
                  <div className="flex flex-row pt-2">
                    <Skeleton className="h-16 rounded-md shadow w-1/4" />
                    <div className="ms-3 self-center">
                      <Skeleton className="h-4 w-full" />
                    </div>
                  </div>
                ) : (
                  <>
                    {newsData?.status === 200 ? (
                      newsData?.data
                        ?.sort(
                          (a, b) =>
                            new Date(b.created_at).getTime() -
                            new Date(a.created_at).getTime()
                        )
                        ?.slice(0, 6)
                        ?.map((item) => (
                          <DynamicNews
                            key={item.id}
                            link={item.slug}
                            title={item.title}
                            image={`https://admin.macspace.id/public/${item.image}`}
                          />
                        ))
                    ) : (
                      <>
                        <h1 className="text-center text-lg text-red-500">
                          Sorry the news is not available
                        </h1>
                      </>
                    )}
                  </>
                )}
              </Suspense>
            </Layouts.SidebarLayanan>
          </div>
        </div>
      </Layouts.Section>
    </>
  );
};

export default NewsLayouts;
